import React from "react";
import { Outlet, useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { useTheme } from "@/lib/theme";
import { Button } from "@/components/ui/button";
import { BedDouble, LogOut, Sun, Moon, ArrowLeftRight, BarChart3 } from "lucide-react";

export default function WardLayout() {
  const { user, logout } = useAuth();
  const { dark, toggle } = useTheme();
  const nav = useNavigate();

  const signOut = () => { localStorage.removeItem("ward_mode"); logout(); nav("/login", { replace: true }); };
  const toNicu = () => { localStorage.removeItem("ward_mode"); nav("/", { replace: true }); };

  return (
    <div className="min-h-screen bg-background" data-testid="ward-layout">
      <header className="border-b border-border bg-card">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 h-14 flex items-center justify-between gap-4">
          <Link to="/ward" className="flex items-center gap-2" data-testid="ward-home-link">
            <div className="h-8 w-8 rounded-lg bg-primary/10 grid place-items-center"><BedDouble size={16} className="text-primary" /></div>
            <div className="leading-tight">
              <div className="font-display font-semibold text-sm">PICU / General Ward</div>
              <div className="text-[10px] uppercase tracking-widest text-muted-foreground">Admission · Billing</div>
            </div>
          </Link>
          <div className="flex items-center gap-2">
            <span className="text-xs text-muted-foreground hidden sm:inline" data-testid="ward-user">{user?.full_name || user?.username}</span>
            <Button variant="ghost" size="sm" onClick={() => nav("/ward/reports")} data-testid="ward-nav-report" title="Daily collection"><BarChart3 size={14} className="sm:mr-1" /><span className="hidden sm:inline">Daily report</span></Button>
            <Button variant="ghost" size="sm" onClick={toNicu} data-testid="ward-switch-nicu" title="Switch to NICU"><ArrowLeftRight size={14} className="mr-1" /> NICU</Button>
            <button onClick={toggle} className="h-8 w-8 rounded-lg border border-border grid place-items-center text-muted-foreground" data-testid="ward-theme-toggle">
              {dark ? <Sun size={14} /> : <Moon size={14} />}
            </button>
            <Button variant="ghost" size="sm" onClick={signOut} data-testid="ward-logout"><LogOut size={14} /></Button>
          </div>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-6"><Outlet /></main>
    </div>
  );
}
